export default "__VITE_ASSET__Du24M68F__"